// extracted by mini-css-extract-plugin
export default {"widgetsToAdd":"styles_widgetsToAdd__bfQ1x","widgetToAdd":"styles_widgetToAdd__04IBC"};